import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';

import useStyles from './styles';
import useStylesHeader from './stylesHeader';

function PaperAvatar({
  title,
  children,
  actions,
  loading,
  photo,
}) {
  const classesRoot = useStyles();
  const classesHeader = useStylesHeader();

  return (
    <Card
      classes={{
        root: classesRoot.root,
      }}
    >
      <CardHeader
        classes={{
          avatar: classesHeader.root
        }}
        avatar={
          <>
            {!loading && <Avatar alt={title} src={photo} className={classesHeader.bigAvatar}/>}
            {loading && <CircularProgress size={80}/>}
          </>
        }
      />
      <CardContent>
        <div>
          <Typography variant="h5" className={classesRoot.title}>
            {title}
          </Typography>

          <div
            className={classesRoot.flex}
          >
            {actions}
          </div>
        </div>
        <Divider className={classesRoot.divider} />
        {!loading && children}
      </CardContent>
    </Card>
  );
}

PaperAvatar.defaultProps = {
  iconColor: 'blue',
  classes: {},
  loading: false,
};

PaperAvatar.propTypes = {
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
  photo: PropTypes.string.isRequired,
  iconColor: PropTypes.oneOf([
    'primary',
    'second',
    'success',
    'warning',
    'error',
    'blue',
    'orange',
    'green',
    'purple',
    'red',
  ]),
  title: PropTypes.node,
  loading: PropTypes.bool,
};

export default PaperAvatar;
